import { render } from "./Cards.vue?vue&type=template&id=556d40a2"
import script from "./Cards.vue?vue&type=script&lang=js"
export * from "./Cards.vue?vue&type=script&lang=js"

import "./Cards.vue?vue&type=style&index=0&id=556d40a2&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__